import React from 'react';
import Layout from '../../components/layout/AppLayout';
import Header from '../../../shared/components/layout/Header';
import SalesReceivables from '../SalesReceivables';
import { useSmartBack } from '../../../shared/navigation';

const SalesReceivablesPage = () => {
  const { onBack } = useSmartBack({ fallback: '/builder/sales/?view=dashboard' });

  return (
    <Layout>
      <div className="flex h-[100dvh] min-h-0 flex-col overflow-hidden">
        <div className="z-50 shrink-0">
          <Header data={{ name: 'Sales Receivables' }} backArrow={true} onBack={onBack} />
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <SalesReceivables />
        </div>
      </div>
    </Layout>
  );
};

export default SalesReceivablesPage;
